export default parseInt;
//# sourceMappingURL=to-integer.js.map